export const CURRENT_COMMUNICATION_PLAN_LOAD =
  'CURRENT_COMMUNICATION_PLAN_LOAD';
export const CURRENT_COMMUNICATION_PLAN_LOAD_START = `${CURRENT_COMMUNICATION_PLAN_LOAD}_START`;
export const CURRENT_COMMUNICATION_PLAN_LOAD_SUCCESS = `${CURRENT_COMMUNICATION_PLAN_LOAD}_SUCCESS`;
export const CURRENT_COMMUNICATION_PLAN_LOAD_FAIL = `${CURRENT_COMMUNICATION_PLAN_LOAD}_FAIL`;
